import React, { useEffect } from 'react'
import ProtectedLayout from '../../layouts/ProtectedLayout';
import { ConsoleSqlOutlined, FileTextOutlined, FormOutlined, LinkOutlined, MailOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { getPost } from '../../redux/actions/post';
import { getCategories } from '../../redux/actions/category';
import { listNewsletters } from '../../redux/actions/newsletter';
import { listContactForms } from '../../redux/actions/contactForm';
import { getProducts } from '../../redux/actions/product';

export const CMSHome = () => {
  const dispatch = useDispatch();
  const { posts } = useSelector((state: RootState) => state.posts);
  const { categories } = useSelector((state: RootState) => state.categories);
  const { newsletters } = useSelector((state: RootState) => state.newsletter);
  const { contactForms } = useSelector((state: RootState) => state.contactForm);
  const { products } = useSelector((state: RootState) => state.products);

  useEffect(() => {
    (dispatch as any)(getPost());
    (dispatch as any)(getCategories());
    dispatch(listNewsletters());
    dispatch(listContactForms());
    dispatch<any>(getProducts());
  }, [dispatch]); 

  return (
    <ProtectedLayout>
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                {/* Blog Sayısı */}
                <div className="bg-blue-50 p-4 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm text-blue-600">Blog Sayısı</p>
                            <h2 className="text-2xl font-bold text-blue-700">{posts?.length}</h2>
                        </div>
                        <div className="bg-blue-100 p-3 rounded-full">
                            <FileTextOutlined className="text-2xl text-blue-600" />
                        </div>
                    </div>
                </div>

                {/* Ürün Sayısı */}
                <div className="bg-green-50 p-4 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm text-green-600">Ürün Sayısı</p>
                            <h2 className="text-2xl font-bold text-green-700">{products?.length}</h2>
                        </div>
                        <div className="bg-green-100 p-3 rounded-full">
                            <ConsoleSqlOutlined className="text-2xl text-green-600" />
                        </div>
                    </div>
                </div>

                {/* Newsletter Sayısı */}
                <div className="bg-purple-50 p-4 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm text-purple-600">Newsletter Sayısı</p>
                            <h2 className="text-2xl font-bold text-purple-700">{newsletters?.length}</h2>
                        </div>
                        <div className="bg-purple-100 p-3 rounded-full">
                            <MailOutlined className="text-2xl text-purple-600" />
                        </div>
                    </div>
                </div>

                {/* İletişim Formu Sayısı */}
                <div className="bg-orange-50 p-4 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm text-orange-600">İletişim Formu</p>
                            <h2 className="text-2xl font-bold text-orange-700">{contactForms?.length}</h2>
                        </div>
                        <div className="bg-orange-100 p-3 rounded-full">
                            <FormOutlined className="text-2xl text-orange-600" />
                        </div>
                    </div>
                </div>

                {/* Kategori Sayısı */}
                <div className="bg-red-50 p-4 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm text-red-600">Kategori Sayısı</p>
                            <h2 className="text-2xl font-bold text-red-700">{categories?.length}</h2>
                        </div>
                        <div className="bg-red-100 p-3 rounded-full">
                            <LinkOutlined className="text-2xl text-red-600" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ProtectedLayout>
  )
}

export default CMSHome;